import { ref, get, set } from 'firebase/database';
import { database } from '../firebase/config';
import { DashboardLayout, DashboardWidget } from '../types/Dashboard';

export interface Avaliacao {
  id: string;
  alunoId: string;
  professorId: string;
  nivelId: string;
  proximoNivel?: string;
  dataAvaliacao: string;
  notaGeral: number;
  aprovado: boolean;
  comentario?: string;
  mudancas?: string;
  createDate: string;
  updateDate?: string;
  deleteDate?: string;
}

class DashboardService {
  async getUserDashboardLayout(empresaCnpj: string, userId: string): Promise<DashboardLayout | null> {
    try {
      const layoutRef = ref(database, `empresas/${empresaCnpj}/usuarios/${userId}/dashboardLayout`);
      const snapshot = await get(layoutRef);
      
      if (snapshot.exists()) {
        return snapshot.val() as DashboardLayout;
      }
      return null;
    } catch (error) {
      console.error('Erro ao buscar layout do dashboard:', error);
      throw error;
    }
  }

  async saveUserDashboardLayout(empresaCnpj: string, userId: string, layout: DashboardLayout): Promise<void> {
    try {
      const layoutRef = ref(database, `empresas/${empresaCnpj}/usuarios/${userId}/dashboardLayout`);
      await set(layoutRef, {
        ...layout,
        updatedAt: new Date().toISOString()
      });
      console.log('✅ Layout do dashboard salvo com sucesso');
    } catch (error) {
      console.error('Erro ao salvar layout do dashboard:', error);
      throw error;
    }
  }

  getDefaultLayout(): DashboardLayout {
    return {
      widgets: [
        {
          id: 'widget-1',
          type: 'metric-card',
          title: 'Alunos Ativos',
          size: 'small',
          position: { x: 0, y: 0 },
          config: { metricType: 'alunos-ativos' }
        },
        {
          id: 'widget-2',
          type: 'metric-card',
          title: 'Mensalidades Pagas',
          size: 'small',
          position: { x: 4, y: 0 },
          config: { metricType: 'mensalidades-pagas' }
        },
        {
          id: 'widget-3',
          type: 'metric-card',
          title: 'Turmas Ativas',
          size: 'small',
          position: { x: 8, y: 0 },
          config: { metricType: 'turmas-ativas' }
        },
        {
          id: 'widget-4',
          type: 'metric-card',
          title: 'Inadimplência',
          size: 'small',
          position: { x: 0, y: 1 },
          config: { metricType: 'inadimplencia' }
        },
        {
          id: 'widget-5',
          type: 'line-chart',
          title: 'Receita vs Alunos',
          size: 'large',
          position: { x: 0, y: 2 },
          config: { chartType: 'receita-vs-alunos' }
        },
        {
          id: 'widget-6',
          type: 'list',
          title: 'Agenda de Hoje',
          size: 'medium',
          position: { x: 0, y: 3 },
          config: { listType: 'agenda-hoje' }
        },
        {
          id: 'widget-7',
          type: 'pie-chart',
          title: 'Distribuição por Níveis',
          size: 'medium',
          position: { x: 6, y: 3 },
          config: { chartType: 'distribuicao-niveis' }
        }
      ],
      layoutVersion: '1.0',
      updatedAt: new Date().toISOString()
    };
  }

}

export const dashboardService = new DashboardService();

